import { SHOW_MODAL, HIDE_MODAL } from "../constants/actionTypes";
import { REPROCESSING_MODAL, VIEW_SOURCE_MODAL, ERROR_MODAL, ADD_SKILL_DETAILS_MODAL, ADD_SCENE_MEDIA_MODAL, DOWNLOAD_CSV_MODAL, UPLOAD_CSV_MODAL, CSV_RESULTS_MODAL, BUILD_BUNDLES_MODAL, CREATE_ACTIVITY_MODAL, CREATE_SKILL_MODAL, CREATE_SKILL_GROUP_MODAL} from '../constants/modalTypes';

const hideModal = dialog => () => ({
    type: HIDE_MODAL,
    dialog: dialog
});

const showModal = (dialog, text = '') => ({
    type: SHOW_MODAL,
    dialog: dialog,
    text: text
});

export const showReprocessingModal = text => showModal(REPROCESSING_MODAL, text);
export const hideReprocessingModal = hideModal(REPROCESSING_MODAL);

export const showViewSourceModal = () => showModal(VIEW_SOURCE_MODAL);
export const hideViewSourceModal = hideModal(VIEW_SOURCE_MODAL);

export const showErrorModal = errorMessage => showModal(ERROR_MODAL, errorMessage);
export const hideErrorModal = hideModal(ERROR_MODAL);

export const showAddSkillDetailsModal = () => showModal(ADD_SKILL_DETAILS_MODAL);
export const hideAddSkillDetailsModal = hideModal(ADD_SKILL_DETAILS_MODAL);

export const showAddSceneMediaModal = () => showModal(ADD_SCENE_MEDIA_MODAL);
export const hideAddSceneMediaModal = hideModal(ADD_SCENE_MEDIA_MODAL);

export const showDownloadCsvModal = () => showModal(DOWNLOAD_CSV_MODAL);
export const hideDownloadCsvModal = hideModal(DOWNLOAD_CSV_MODAL);

export const showUploadCsvModal = () => showModal(UPLOAD_CSV_MODAL);
export const hideUploadCsvModal = hideModal(UPLOAD_CSV_MODAL);

export const showCsvResultsModal = () => showModal(CSV_RESULTS_MODAL);
export const hideCsvResultsModal = hideModal(CSV_RESULTS_MODAL);

export const showBuildBundlesModal = () => showModal(BUILD_BUNDLES_MODAL);
export const hideBuildBundlesModal = hideModal(BUILD_BUNDLES_MODAL);

export const showCreateSkillModal = () => showModal(CREATE_SKILL_MODAL);
export const hideCreateSkillModal = hideModal(CREATE_SKILL_MODAL);

export const showCreateActivityModal = () => showModal(CREATE_ACTIVITY_MODAL);
export const hideCreateActivityModal = hideModal(CREATE_ACTIVITY_MODAL);

export const showCreateSkillGroupModal = () => showModal(CREATE_SKILL_GROUP_MODAL);
export const hideCreateSkillGroupModal = hideModal(CREATE_SKILL_GROUP_MODAL);



// WEBPACK FOOTER //
// ./src/actions/modal.js